import Component from '@glimmer/component'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'
import { action } from '@ember/object'
import { tracked } from '@glimmer/tracking'
import { t } from 'ember-intl'
import { on } from '@ember/modifier'

import scrollDrag from 'teacher-ui-client/modifiers/scroll-drag'

interface Signature {
  Element: HTMLDivElement
  Args: {
    /** Position buttons outside of the carousel, rather than on top */
    navButtonsOutside?: boolean
    /** Only show nav buttons when the carousel is hovered */
    navButtonsOnHover?: boolean
    fadeSides?: boolean
  }
  Blocks: {
    default: []
  }
}

export class CarouselScrollComponent extends Component<Signature> {
  @tracked onPagePrev: null | (() => void) = null

  @tracked onPageNext: null | (() => void) = null

  // Set left/right actions
  @action
  setPageNav(scrollPageLeft: null | (() => void), scrollPageRight: null | (() => void)) {
    this.onPagePrev = scrollPageLeft
    this.onPageNext = scrollPageRight
  }

  <template>
    <div class="group relative {{if @navButtonsOutside 'mx-12'}}" ...attributes>
      <div
        class="no-scrollbars overflow-x-auto whitespace-nowrap {{if @fadeSides 'fade-sides'}}"
        {{scrollDrag contentSelector=".scroll-content" setPageNav=this.setPageNav}}
      >
        <div class="scroll-content">
          {{yield}}
        </div>
      </div>
      {{#if this.onPagePrev}}
        <button
          data-test-page-prev
          class="absolute top-1/2 mx-4 -translate-y-1/2 cursor-pointer rounded-full text-center opacity-75 hover:opacity-100 focus:outline-hidden active:outline-hidden
            {{if @navButtonsOutside '-left-12 m-0'}}
            {{if @navButtonsOnHover 'invisible group-hover:visible'}}"
          aria-label={{t "base.carouselScroll.previous"}}
          type="button"
          {{on "click" this.onPagePrev}}
        >

          <PhosphorIcon @icon="phosphor-caret-circle-left-fill" class="h-12 w-12 pl-1 text-black" />
        </button>
      {{/if}}
      {{#if this.onPageNext}}
        <button
          data-test-page-next
          class="absolute top-1/2 right-0 mx-4 -translate-y-1/2 cursor-pointer rounded-full text-center opacity-75 hover:opacity-100 focus:outline-hidden active:outline-hidden
            {{if @navButtonsOutside '-right-12 m-0'}}
            {{if @navButtonsOnHover 'invisible group-hover:visible'}}"
          aria-label={{t "base.carouselScroll.next"}}
          type="button"
          {{on "click" this.onPageNext}}
        >

          <PhosphorIcon @icon="phosphor-caret-circle-right-fill" class="h-12 w-12 pl-1 text-black" />
        </button>
      {{/if}}
    </div>
  </template>
}

export default CarouselScrollComponent
